import { Content } from '@/types/content';
import { mergeDefined } from '@/utils/mergeDefined';
import { findAllOfType } from 'lib/labrador/content-operations/findBy';
import { CollectionPage, ListItem, WithContext } from 'schema-dts';
import {
  CustomSchemaMarkupConfig,
  getPublishedUrl,
  publisher
} from './utils';

const mapArticlesToSchema = (articles: Content[]): ListItem[] => {
  return articles.map((article, idx) => {
    const { data } = article ?? {};
    const { publishedUrl } = data ?? {};

    return {
      '@type': 'ListItem',
      position: idx+1,      
      url: getPublishedUrl(publishedUrl)      
    } as ListItem;
  });
};

export const getCollectionPageSchema = (
  pageData: Content,
  schema?: Partial<CollectionPage & CustomSchemaMarkupConfig>,
): WithContext<CollectionPage & CustomSchemaMarkupConfig> => {
  const { data, children } = pageData ?? {};
  const { publishedUrl, canonical, seoTitle, title, seoDescription, subtitle } =
    data ?? {};

  const url = publishedUrl === '/etikett' ? canonical : getPublishedUrl(publishedUrl);
  const articles = findAllOfType(children, 'articleTeaser');

  const collectionPageSchema: Partial<WithContext<CollectionPage & CustomSchemaMarkupConfig>> = {
    '@context': 'https://schema.org',
    '@type': 'CollectionPage',
    name: seoTitle || title || '',
    description: seoDescription || subtitle || '',
    url,
    publisher,
    mainEntity: {
      '@type': 'ItemList',
      "numberOfItems": pageData.meta.totalCount || undefined,
      itemListElement: mapArticlesToSchema(articles),
    },
  };

  return mergeDefined(collectionPageSchema, schema);
};
